<script setup lang="ts">
  import { IParkMapCmsData } from "@/view-models/parkmap.model"

  const cmsData = CMSDataProvider.get<IParkMapCmsData>(CMS_DATA_ID.MAP)

  const urlWithoutCrop = computed(() => {
    return cmsData.imageCropUrl.split("?")[0]
  })
</script>

<template>
  <section class="theme-softGreen pb-32 px-0">
    <div class="container"> 
      <a
        class="w-full flex lg:justify-end px-4"
        :href="cmsData.imageDownload"
        download="Apenheul-Plattegrond"
      >
        <button class="button w-full bg-none border border-wg-500 flex justify-center lg:w-fit lg:justify-end">
          <svg
            class="icon icon-download size-6 fill-wg-200"
            role="presentation"
          >
            <use xlink:href="#icon-download" />
          </svg>
          <span class="uppercase text-wg-200"> {{ cmsData.downloadMapLabel }} </span>
        </button>
      </a>
    </div>

    <div
      class="plattegrond-full  "
    >
      <picture class="relative grid h-full">
        <source
          :image="`${urlWithoutCrop}?width=3840&height=3840`"
          min-width="1920"
          width="3840"
          height="3840"
        />
        <source
          :image="`${urlWithoutCrop}?width=3072&height=3072`"
          min-width="1536"
          width="3072"
          height="3072"
        />
        <source
          :image="`${urlWithoutCrop}?width=2560&height=2560`"
          min-width="1280"
          width="2560"
          height="2560"
        />
        <source
          :image="`${urlWithoutCrop}?width=1536&height=1536`"
          min-width="768"
          width="1536"
          height="1536"
        />
        <source
          :image="`${urlWithoutCrop}?width=1280&height=1280`"
          min-width="640"
          width="1280"
          height="1280"
        />
        <source
          :image="`${urlWithoutCrop}?width=864&height=864`"
          max-width="640"
          width="864"
          height="864"
        />
        <img
          class="min-w-[1000px] mx-auto"
          :src="`${urlWithoutCrop}?width=2560&height=2560`"
          width="1176"
          height="1046"
          alt=""
        />
      </picture>
    </div>
  </section>
</template>
